<script setup lang="ts">
import ElementalPage from '../../@components/ElementalPage.vue'
import type { RouterQueryParams } from '~~/src/types/router-query'
import { ElementalTypeEnum } from '~~/src/types/elemental'

const route = useRoute()
const viewType = computed<RouterQueryParams['view_type']>(() => route.query?.view_type as RouterQueryParams['view_type'] ?? 'public')
const router = useRouter()

if (viewType.value !== 'feed') {
  router.push({
    path: route.path,
    query: {
      ...route.query,
      view_type: 'feed',
    },
  })
}
</script>

<template>
  <ElementalPage v-if="viewType === 'feed'" force-view="feed" :type="ElementalTypeEnum.Table" />
</template>
